/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { APIGateways } from "../../../utility/APIGateways";
import { getAuthHeader } from "../../..//utility/auth";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";

const COMPONENT_NAME = "Admin promptsManager/services/uploadToS3Service";

const uploadToS3 = async (pathName, content) => {
	try {
		const result = await fetch(APIGateways.uploadToS3Endpoint, {
			method: "POST",
			headers: await getAuthHeader(),
			body: JSON.stringify({
				pathName,
				content,
			}),
		});

		return await result.json();
	} catch (error) {
		v2.error("Error while uploading prompts to s3", {
			additionalData: { error: errorToObject(error), data: { pathName, content } },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.UPLOAD_PROMPTS_API_ERROR,
		});
		return error;
	}
};

export const getProcessState = async (fileName) => {
	try {
		const response = await fetch(`${APIGateways.checkCsvProcessingStateEndpoint}?fileName=${fileName}`, {
			method: "GET",
			headers: await getAuthHeader(),
		});
		const { processingState } = (await response.json()) || {};
		return processingState;
	} catch (error) {
		return "failed";
	}
};

export default uploadToS3;
